import { shouldForwardPrimitiveProp as e } from "./primitiveProps.mjs";
import { Col as t, Row as n } from "./Flex.mjs";
import { styled as r } from "styled-components";
//#region src/components/Primitives/Stack.tsx
var i = r(n)``;
i.displayName = "HStack";
var a = r(t)``;
a.displayName = "VStack";
var o = r.div`
    flex: 1;
`;
o.displayName = "Spacer";
var s = r.hr.withConfig({ shouldForwardProp: e })`
    border: none;
    background-color: ${({ theme: e }) => e.colors.border};
    margin: 0;
    ${({ $vertical: e }) => e ? "width: 1px; height: auto; align-self: stretch;" : "height: 1px; width: 100%;"}
`;
s.displayName = "Divider";
//#endregion
export { s as Divider, i as HStack, o as Spacer, a as VStack };
